import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { BrandMarquee } from "@/components/site/BrandMarquee";
import { MobileBand } from "@/components/site/MobileBand";
import { Services } from "@/components/site/Services";
import { European } from "@/components/site/European";
import { Process } from "@/components/site/Process";
import { Gallery } from "@/components/site/Gallery";
import { QuoteCta } from "@/components/site/QuoteCta";
import { Areas } from "@/components/site/Areas";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { useSmoothScroll } from "@/components/site/smooth";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { Reviews } from "@/components/site/Reviews";

export default function Home() {
  useSmoothScroll();
  return (
    <div data-testid="home-page" className="grain relative bg-ink text-bone">
      <Nav />
      <main>
        <Hero />
        <BrandMarquee />
        <MobileBand />
        <Services />
        <European />
        <Process />
        <Gallery />
        <Reviews />
        <QuoteCta />
        <Areas />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
